export const TIME_ZONE = 'Europe/Kyiv';
